import { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useApi } from "../hooks/useApi";

export default function AddCode() {
    const { codeId } = useParams();  // Get the code ID from the URL
    const [codeData, setCodeData] = useState(null);
    const { apiCall } = useApi();
    const initialized = useRef(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;

            apiCall(`fetch_code`, { params: { code_id: codeId } })
                .then(response => response.json())
                .then(data => setCodeData(data))
                .catch(error => console.error("Error fetching code data:", error));

        }
    });

    const setData = (key, value) => {
        setCodeData((prevData) => ({ ...prevData, [key]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await apiCall(`update_code`, {
                params: { code_id: codeId },
                method: "POST",
                body: codeData,
            });
            const data = await response.json();
            if (!data.success) {
                console.log(data.error);
                throw new Error(data.error);
            }

            alert("Code updated successfully!");
        } catch (error) {
            alert("Error: " + error);
        }
    }
    const deleteCode = async () => {

        if (!confirm("Are you sure you want to delete this code? This action cannot be undone.")) {
            return; // User canceled the deletion
        }
        try {
            const response = await apiCall(`delete_code`, { params: { code: codeId } });
            const data = await response.json();
            if (!data.success) {
                throw new Error(data.message);
            }

            alert("Code deleted successfully!");
            navigate("/cost-codes"); // Redirect to the sites list page after deletion
        } catch (error) {
            alert("Error deleting the code:" + error);
        }
    }

    return (
        <>
            {codeData && (
                <div className="p-6">
                    <div className="flex justify-between items-center mb-10">
                        <h1 className="text-2xl font-bold">Edit Code</h1>

                        <Link to={`/cost-codes/`} className="btn btn-primary self-end">
                            Back
                        </Link>
                    </div>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <input
                            type="text"
                            placeholder="Project#"
                            value={codeData?.projectNumber || ""}
                            onChange={(e) => setData('projectNumber', e.target.value)}
                            className="border p-2 rounded w-full"
                            required
                        />
                        <input
                            type="text"
                            placeholder="DBID"
                            value={codeData?.dbid || ""}
                            onChange={(e) => setData('dbid', e.target.value)}
                            className="border p-2 rounded w-full"
                            required
                        />
                        <input
                            type="text"
                            placeholder="Code"
                            value={codeData?.code || ""}
                            onChange={(e) => setData('code', e.target.value)}
                            className="border p-2 rounded w-full"
                            required
                        />
                        <input
                            type="text"
                            placeholder="Description"
                            value={codeData?.description || ""}
                            onChange={(e) => setData('description', e.target.value)}
                            className="border p-2 rounded w-full"
                            required
                        />
                        <input
                            type="text"
                            placeholder="Cost Type"
                            value={codeData?.costType || "M"}
                            onChange={(e) => setData('costType', e.target.value)}
                            className="border p-2 rounded w-full"
                            required
                        />
                        <input
                            type="text"
                            placeholder="Phase"
                            value={codeData?.phase || ""}
                            onChange={(e) => setData('phase', e.target.value)}
                            className="border p-2 rounded w-full"
                        />
                        <input
                            type="text"
                            placeholder="Location"
                            value={codeData?.location || ""}
                            onChange={(e) => setData('location', e.target.value)}
                            className="border p-2 rounded w-full"
                        />
                        <div className="flex items-center mb-4 justify-between">
                            <div className="flex items-center mr-4">
                                <button type="submit" className="btn btn-primary">Update Code</button>
                                <Link to={`/cost-codes/`}>
                                    <button type="button" className="btn btn-cancel ml-4">Cancel</button>
                                </Link>
                            </div>
                            {/*                             <button type="button" className="bg-red-500 text-white p-2 rounded cursor-pointer ml-4" onClick={deleteCode}>Delete Code</button>
 */}                        </div>


                    </form>
                </div>
            )}
        </>
    );

};